<template>
    <v-container class="ufv-container-pages">
        <ViewTela
            v-if="tela != null"
            :servicoAtendimento="servicoAtendimento"
        />
    </v-container>
</template>

<script>
import ViewTela from "../../../views/atendimento/arvore/ViewTela";

export default {
    name: "arvore",
    components: {
        ViewTela,
    },
    props: {
        servicoAtendimento: {
            type: Object,
            required: true,
        },
    },
    computed: {
        tela() {
            return this.servicoAtendimento.telaAtual();
        },
    },
};
</script>
